__turbopack_context__.v({
  "root": "AccordionGroupsBlok-module__SbUcUW__root",
});
